export function extractFileNameFromUrl(url: string): string {
  try {
    const urlObject = new URL(url);
    const pathname = urlObject.pathname;
    const fileName = pathname.substring(pathname.lastIndexOf("/") + 1);
    return decodeURIComponent(fileName);
  } catch (error) {
    console.error("Invalid URL:", error);
    return "";
  }
}
